const imageViewTemplate = ({mediaTagUniqueId}) => `
<div id="${mediaTagUniqueId}" class="media-container image-container" aria-hidden="true">
   <div class="image-div">
      <img class="smart-player-image-media" />
   </div>
   <div class="media-plugin-container"></div>
</div>`;

export default imageViewTemplate;
